import { createTheme } from '@material-ui/core';
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";

const theme = createTheme({
  status: {
    warning: '#ff9300',
    info: '#258ff8',
    danger: '#d10244'
  },
  palette: {
    primary: {
      main: '#258ff8'
    },
    secondary: {
      main: '#ff9300'
    },
    grey: {
      light: '#f6f7f8',
      main: '#707070',
      dark: '#202124',
    },
    blueGrey: {
      light: '#cdd5d8'
    },
    red: {
      main: '#d10244',
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 980,
      lg: 1280,
      xl: 1920,
    },
  },
  typography: {
    fontFamily: 'Helvetica, Arial, sans-serif',
    fontSize: 12,
    htmlFontSize: 12,
    body2: {
      color: '#707070',
    }
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        html: {
          fontSize: '12px'
        }
      }
    },
    MuiInputBase: {
      root: {
        borderRadius: 5,
        border: `1px solid #cdd5d8`,
        height: 38,
        padding: '6px 10px',
        fontSize: `13px`,
        '&.Mui-error': {
          color: '#d10244',
          border: '2px solid #d10244',
        }
      },
      input: {
        padding: '7px 0'
      },
    },
    MuiToggleButtonGroup: {
      root: {
        justifyContent: 'space-between',
        display: 'flex',
        width: 'calc(100% + 16px)',
        margin: -8,
      },
      grouped: {
        margin: 4,
        border: 'none',
      },
    },
    MuiToggleButton: {
      root: {
        borderRadius: '4px !important',
        display: 'block',
        margin: 8,
        flexGrow: 4,
        flexBasis: 80,
        textAlign: 'left',
        border: `1px solid #cdd5d8 !important`,
        color: '#202124 !important',
        '&.Mui-selected': {
          backgroundColor: 'transparent !important',
          border: '2px solid #258ff8',
          color: '#258ff8',
        }
      },
    },
    MuiButton: {
      root: {
        borderRadius: 5,
        height: 44,
      },
      label: {
        color: '#fff',
        fontSize: 14,
        fontWeight: 600,
      }
    },
    MuiLink: {
      root: {
        color: '#202124',
      }
    },
    MuiTypography: {
      h3: {
        fontSize: 14,
        fontWeight: 700,
      },
      body1: {
        fontSize: 12,
      }
    },
    MuiFormHelperText: {
      root: {
        '&.Mui-error': {
          color: '#d10244',
        }
      }
    }
  },
});

export default theme;
